import { JOB_STATUS_META, PKG_STATUS_META } from "@/lib/apiClient";
import { cn } from "@/lib/utils";

export function JobStatusBadge({ status, className }) {
  const meta = JOB_STATUS_META[status] || JOB_STATUS_META.active;
  return (
    <span
      data-testid={`job-status-badge-${status}`}
      className={cn("inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wide", meta.classes, className)}
    >
      {meta.label}
    </span>
  );
}

export function PkgStatusBadge({ status }) {
  const cls = PKG_STATUS_META[status] || PKG_STATUS_META["TBA"];
  return (
    <span className={cn("inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide", cls)}>
      {status}
    </span>
  );
}
